function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regeneratorValues(e) { if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
    if (t)
        return t.call(e);
    if ("function" == typeof e.next)
        return e;
    if (!isNaN(e.length))
        return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } };
} throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Tooltip, Checkbox, CircularProgress, Alert, Chip } from '@mui/material';
import { Add as AddIcon, DeleteOutlined as DeleteIcon, ListAltOutlined as EditIcon, InfoOutlined as InfoIcon, FilterListOutlined as FilterIcon, ForwardToInbox as ResendIcon, Autorenew as ResetIcon } from '@mui/icons-material';
import AddUserModal from '../components/AddUserModal';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
import UserDetailsModal from '../components/UserDetailsModal';
import { UserAPI } from '../apis/UserAPI';
import { isAuthorized } from '../utils/utilities';
import authenticatedRoute from '../views/AuthenticatedRoute';
import { RBAC_CONSTANTS, constants } from '../constants';
import { useThemeDetails } from '../components/ThemeDetailsContext';
// Helper function to get status chip background color
var getStatusBackgroundColor = function getStatusBackgroundColor(status) {
    if (status === RBAC_CONSTANTS.rbac_user_status_active) {
        return '#f3f8eb';
    }
    if (status === RBAC_CONSTANTS.rbac_user_status_pending) {
        return '#fef6ea';
    }
    return '#fce4ec';
};
// Helper function to get status chip text color
var getStatusTextColor = function getStatusTextColor(status) {
    if (status === RBAC_CONSTANTS.rbac_user_status_active) {
        return '#1a5d09';
    }
    if (status === RBAC_CONSTANTS.rbac_user_status_pending) {
        return '#9f6514';
    }
    return '#c62828';
};
// Helper function to correct user roles (extracted to reduce nesting)
var correctUserRoles = function correctUserRoles(user, roles) {
    var userRoles = Array.isArray(user.role) ? user.role : [user.role];
    // Dedupe roles first and filter empty values
    var uniqueRoles = Array.from(new Set(userRoles)).filter(function (role) {
        return role && role.trim() !== '';
    });
    var validRoles = uniqueRoles.filter(function (role) {
        return roles.some(function (availableRole) {
            return availableRole.role_name === role;
        });
    });
    if (validRoles.length === 0) {
        // Don't assign a default role - show empty if user has no valid roles
        return _objectSpread(_objectSpread({}, user), {}, {
            role: []
        });
    }
    if (validRoles.length !== uniqueRoles.length) {
        console.warn("User ".concat(user.email, " has some invalid roles, keeping only valid ones: \"").concat(validRoles.join(', '), "\""));
        return _objectSpread(_objectSpread({}, user), {}, {
            role: validRoles
        });
    }
    return _objectSpread(_objectSpread({}, user), {}, {
        role: uniqueRoles
    });
};
// Helper function to process a single user
var processSingleUser = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(userData, selectedUser, validateUserData, validateUserRoles, updateExistingUser, createNewUser) {
        var userRoles, selectedRoleObjs, _userData$avatarUrl, _userData$status, _userData$isExternal, newUser;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.n) {
                    case 0:
                        userRoles = [];
                        if (Array.isArray(userData.role)) {
                            userRoles = Array.from(new Set(userData.role)).filter(Boolean); // Dedupe and filter empty strings
                        }
                        else if (userData.role) {
                            userRoles = [userData.role];
                        }
                        else {
                            userRoles = [];
                        }
                        validateUserData(userData, selectedUser);
                        // Only validate roles if roles are provided
                        selectedRoleObjs = userRoles.length > 0 ? validateUserRoles(userRoles) : [];
                        if (!selectedUser) {
                            _context.n = 2;
                            break;
                        }
                        _context.n = 1;
                        return updateExistingUser(userData, selectedRoleObjs);
                    case 1:
                        return _context.a(2, null);
                    case 2:
                        _context.n = 3;
                        return createNewUser(userData, selectedRoleObjs);
                    case 3:
                        newUser = _context.v;
                        return _context.a(2, {
                            id: newUser.id,
                            avatarUrl: (_userData$avatarUrl = userData.avatarUrl) !== null && _userData$avatarUrl !== void 0 ? _userData$avatarUrl : '',
                            name: userData.name,
                            email: userData.email,
                            phone: userData.phone,
                            role: userRoles,
                            groups: [],
                            // New users have no groups initially
                            status: (_userData$status = userData.status) !== null && _userData$status !== void 0 ? _userData$status : 'active',
                            dateAdded: new Date().toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                            }),
                            isExternal: (_userData$isExternal = userData.isExternal) !== null && _userData$isExternal !== void 0 ? _userData$isExternal : false,
                            extUserId: newUser.id
                        });
                    case 4:
                        return _context.a(2);
                }
        }, _callee);
    }));
    return function processSingleUser(_x, _x2, _x3, _x4, _x5, _x6) {
        return _ref.apply(this, arguments);
    };
}();
// Helper function to handle save results
var handleSaveResults = function handleSaveResults(newUsers, errors, setUsers, setUserModalError, setUserModalOpen, isUpdate) {
    if (newUsers.length > 0) {
        setUsers(function (prevUsers) {
            return [].concat(_toConsumableArray(prevUsers), _toConsumableArray(newUsers));
        });
    }
    if (errors.length > 0 && newUsers.length > 0) {
        setUserModalError(constants.team_access_error_some_users_could_not_be_added(errors.join(', ')));
        // Keep modal open when there are errors
    }
    else if (errors.length > 0 && (newUsers.length === 0 || isUpdate)) {
        setUserModalError(constants.team_access_error_failed_to_add_users(errors.join(', ')));
        // Keep modal open when there are errors
    }
    else if (newUsers.length > 0 || isUpdate) {
        console.log(isUpdate ? 'Successfully updated user' : "Successfully added ".concat(newUsers.length, " user(s)"));
        setUserModalError(null);
        setUserModalOpen(false);
    }
};
var TeamAccess = function TeamAccess() {
    var _userToDelete$name;
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), users = _useState2[0], setUsers = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), roles = _useState4[0], setRoles = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), selectedUsers = _useState6[0], setSelectedUsers = _useState6[1];
    var _useState7 = useState(false), _useState8 = _slicedToArray(_useState7, 2), loading = _useState8[0], setLoading = _useState8[1];
    var _useState9 = useState(true), _useState0 = _slicedToArray(_useState9, 2), dataLoading = _useState0[0], setDataLoading = _useState0[1];
    var _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), error = _useState10[0], setError = _useState10[1];
    var _useState11 = useState(null), _useState12 = _slicedToArray(_useState11, 2), userModalError = _useState12[0], setUserModalError = _useState12[1];
    // Modal and dialog state
    var _useState13 = useState(false), _useState14 = _slicedToArray(_useState13, 2), userModalOpen = _useState14[0], setUserModalOpen = _useState14[1];
    var _useState15 = useState(null), _useState16 = _slicedToArray(_useState15, 2), selectedUser = _useState16[0], setSelectedUser = _useState16[1];
    var _useState17 = useState(false), _useState18 = _slicedToArray(_useState17, 2), confirmDialogOpen = _useState18[0], setConfirmDialogOpen = _useState18[1];
    var _useState19 = useState(null), _useState20 = _slicedToArray(_useState19, 2), userToDelete = _useState20[0], setUserToDelete = _useState20[1];
    var _useState21 = useState(false), _useState22 = _slicedToArray(_useState21, 2), userDetailsModalOpen = _useState22[0], setUserDetailsModalOpen = _useState22[1];
    var _useState23 = useState(null), _useState24 = _slicedToArray(_useState23, 2), selectedUserForDetails = _useState24[0], setSelectedUserForDetails = _useState24[1];
    // Load data on component mount
    useEffect(function () {
        loadInitialData();
    }, []);
    var loadInitialData = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            var _yield$Promise$all, _yield$Promise$all2, usersWithRolesResponse, rolesResponse, usersWithRoles, _t;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            setDataLoading(true);
                            setError(null);
                            _context2.p = 1;
                            _context2.n = 2;
                            return Promise.all([UserAPI.getAllApplications(), UserAPI.getUsersWithRoles(), UserAPI.getRoles()]);
                        case 2:
                            _yield$Promise$all = _context2.v;
                            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                            usersWithRolesResponse = _yield$Promise$all2[1];
                            rolesResponse = _yield$Promise$all2[2];
                            setRoles(rolesResponse.resource);
                            // Transform the aggregated user data to match the existing format
                            usersWithRoles = usersWithRolesResponse.resource.map(function (user) {
                                var _user$roles$map, _user$roles, _user$userAttributes, _user$groups$map, _user$groups, _user$userAttributes$, _user$userAttributes2, _user$userAttributes$2, _user$userAttributes3, _user$userAttributes4, _user$metadata, _user$userAttributes$3, _user$userAttributes5, _user$userAttributes6;
                                var userRoles = (_user$roles$map = (_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.map(function (roleObj) {
                                    return roleObj.role_name;
                                })) !== null && _user$roles$map !== void 0 ? _user$roles$map : [];
                                var userStatus = (_user$userAttributes = user.userAttributes) === null || _user$userAttributes === void 0 ? void 0 : _user$userAttributes.status;
                                var status = userStatus === RBAC_CONSTANTS.rbac_user_status_active || userStatus === RBAC_CONSTANTS.rbac_user_status_pending || userStatus === RBAC_CONSTANTS.rbac_user_status_inactive ? userStatus : RBAC_CONSTANTS.rbac_user_status_active;
                                // Get user groups
                                var userGroups = (_user$groups$map = (_user$groups = user.groups) === null || _user$groups === void 0 ? void 0 : _user$groups.map(function (groupObj) {
                                    return groupObj.group_name;
                                })) !== null && _user$groups$map !== void 0 ? _user$groups$map : [];
                                return {
                                    id: user.id,
                                    avatarUrl: '',
                                    name: (_user$userAttributes$ = (_user$userAttributes2 = user.userAttributes) === null || _user$userAttributes2 === void 0 ? void 0 : _user$userAttributes2.name) !== null && _user$userAttributes$ !== void 0 ? _user$userAttributes$ : user.username,
                                    email: (_user$userAttributes$2 = (_user$userAttributes3 = user.userAttributes) === null || _user$userAttributes3 === void 0 ? void 0 : _user$userAttributes3.email) !== null && _user$userAttributes$2 !== void 0 ? _user$userAttributes$2 : user.username,
                                    phone: (_user$userAttributes4 = user.userAttributes) === null || _user$userAttributes4 === void 0 ? void 0 : _user$userAttributes4.phone,
                                    role: userRoles,
                                    // Support multiple roles
                                    groups: userGroups,
                                    // User groups
                                    status: status,
                                    dateAdded: (_user$metadata = user.metadata) !== null && _user$metadata !== void 0 && _user$metadata.createdDate ? new Date(user.metadata.createdDate).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }) : constants.team_access_date_unknown,
                                    isExternal: (_user$userAttributes$3 = (_user$userAttributes5 = user.userAttributes) === null || _user$userAttributes5 === void 0 ? void 0 : _user$userAttributes5.isExternal) !== null && _user$userAttributes$3 !== void 0 ? _user$userAttributes$3 : false,
                                    extUserId: (_user$userAttributes6 = user.userAttributes) === null || _user$userAttributes6 === void 0 ? void 0 : _user$userAttributes6.extUserId
                                };
                            });
                            setUsers(usersWithRoles);
                            _context2.n = 4;
                            break;
                        case 3:
                            _context2.p = 3;
                            _t = _context2.v;
                            console.error('Failed to load data:', _t);
                            setError(constants.team_access_error_load_users_roles);
                        case 4:
                            _context2.p = 4;
                            setDataLoading(false);
                            return _context2.f(4);
                        case 5:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[1, 3, 4, 5]]);
        }));
        return function loadInitialData() {
            return _ref2.apply(this, arguments);
        };
    }();
    // Effect to correct user roles when roles are loaded
    useEffect(function () {
        if (roles.length > 0 && users.length > 0) {
            var correctedUsers = users.map(function (user) {
                return correctUserRoles(user, roles);
            });
            // Only update if there were changes
            var hasChanges = correctedUsers.some(function (user, index) {
                var originalRoles = Array.isArray(users[index].role) ? users[index].role : [users[index].role];
                var correctedRoles = Array.isArray(user.role) ? user.role : [user.role];
                return JSON.stringify(originalRoles.sort()) !== JSON.stringify(correctedRoles.sort());
            });
            if (hasChanges) {
                setUsers(correctedUsers);
            }
        }
    }, [roles, users.length]); // Only depend on roles and users.length to avoid infinite loops
    // Handler functions
    var handleAddUser = function handleAddUser() {
        setSelectedUser(null);
        setUserModalOpen(true);
    };
    // Bulk delete handler
    var handleBulkDeleteUsers = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var _iterator, _step, _loop, _t2, _t3;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.p = _context4.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context4.p = 1;
                            _iterator = _createForOfIteratorHelper(selectedUsers);
                            _context4.p = 2;
                            _loop = /*#__PURE__*/ _regenerator().m(function _loop() {
                                var userId, user;
                                return _regenerator().w(function (_context3) {
                                    while (1)
                                        switch (_context3.n) {
                                            case 0:
                                                userId = _step.value;
                                                user = users.find(function (u) {
                                                    return u.id === userId;
                                                });
                                                if (!user) {
                                                    _context3.n = 1;
                                                    break;
                                                }
                                                _context3.n = 1;
                                                return UserAPI.deleteUser(user.id);
                                            case 1:
                                                return _context3.a(2);
                                        }
                                }, _loop);
                            });
                            _iterator.s();
                        case 3:
                            if ((_step = _iterator.n()).done) {
                                _context4.n = 5;
                                break;
                            }
                            return _context4.d(_regeneratorValues(_loop()), 4);
                        case 4:
                            _context4.n = 3;
                            break;
                        case 5:
                            _context4.n = 7;
                            break;
                        case 6:
                            _context4.p = 6;
                            _t2 = _context4.v;
                            _iterator.e(_t2);
                        case 7:
                            _context4.p = 7;
                            _iterator.f();
                            return _context4.f(7);
                        case 8:
                            setUsers(function (prevUsers) {
                                return prevUsers.filter(function (u) {
                                    return !selectedUsers.includes(u.id);
                                });
                            });
                            setSelectedUsers([]);
                            _context4.n = 10;
                            break;
                        case 9:
                            _context4.p = 9;
                            _t3 = _context4.v;
                            console.error('Failed to bulk delete users:', _t3);
                            setError(constants.team_access_error_delete_user);
                        case 10:
                            _context4.p = 10;
                            setLoading(false);
                            return _context4.f(10);
                        case 11:
                            return _context4.a(2);
                    }
            }, _callee3, null, [[2, 6, 7, 8], [1, 9, 10, 11]]);
        }));
        return function handleBulkDeleteUsers() {
            return _ref3.apply(this, arguments);
        };
    }();
    var handleEditUser = function handleEditUser(user) {
        setSelectedUser(user);
        setUserModalOpen(true);
    };
    var handleViewUserDetails = function handleViewUserDetails(user) {
        setSelectedUserForDetails(user);
        setUserDetailsModalOpen(true);
    };
    var handleDeleteUser = function handleDeleteUser(user) {
        setUserToDelete(user);
        setConfirmDialogOpen(true);
    };
    // Helper function to validate and find role objects
    var validateUserRoles = function validateUserRoles(userRoles) {
        return userRoles.map(function (roleName) {
            var roleObj = roles.find(function (role) {
                return role.role_name === roleName;
            });
            if (!roleObj) {
                throw new Error("Role '".concat(roleName, "' not found"));
            }
            return roleObj;
        });
    };
    // Helper function to validate user data
    var validateUserData = function validateUserData(userData, editingUser) {
        var _userData$email;
        if (!((_userData$email = userData.email) !== null && _userData$email !== void 0 && _userData$email.includes('@'))) {
            throw new Error('Invalid email address');
        }
        var existingUser = users.find(function (u) {
            return u.email === userData.email;
        });
        // Skip check if we're editing the same user
        if (existingUser && existingUser.id !== (editingUser === null || editingUser === void 0 ? void 0 : editingUser.id)) {
            throw new Error('User already exists');
        }
    };
    // Helper function to create a new user
    var createNewUser = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(userData, selectedRoleObjs) {
            var createData, response, newUser, _iterator2, _step2, roleObj, _t4;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.p = _context5.n) {
                        case 0:
                            createData = {
                                resourceType: 'User',
                                username: userData.email,
                                organization_id: 1,
                                principal_type: 1,
                                userAttributes: {
                                    name: userData.name,
                                    email: userData.email,
                                    phone: userData.phone
                                }
                            };
                            _context5.n = 1;
                            return UserAPI.createUser(createData);
                        case 1:
                            response = _context5.v;
                            newUser = response;
                            if (!(!(newUser !== null && newUser !== void 0 && newUser.id) || !(newUser !== null && newUser !== void 0 && newUser.username))) {
                                _context5.n = 2;
                                break;
                            }
                            throw new Error('User creation succeeded but returned incomplete user data');
                        case 2:
                            _context5.n = 3;
                            return new Promise(function (resolve) {
                                return setTimeout(resolve, 100);
                            });
                        case 3:
                            // Assign each role sequentially (only if roles are provided)
                            _iterator2 = _createForOfIteratorHelper(selectedRoleObjs);
                            _context5.p = 4;
                            _iterator2.s();
                        case 5:
                            if ((_step2 = _iterator2.n()).done) {
                                _context5.n = 7;
                                break;
                            }
                            roleObj = _step2.value;
                            _context5.n = 6;
                            return UserAPI.assignRole(newUser.username, {
                                roleId: Number.parseInt(roleObj.role_id)
                            });
                        case 6:
                            _context5.n = 5;
                            break;
                        case 7:
                            _context5.n = 9;
                            break;
                        case 8:
                            _context5.p = 8;
                            _t4 = _context5.v;
                            _iterator2.e(_t4);
                        case 9:
                            _context5.p = 9;
                            _iterator2.f();
                            return _context5.f(9);
                        case 10:
                            return _context5.a(2, newUser);
                    }
            }, _callee4, null, [[4, 8, 9, 10]]);
        }));
        return function createNewUser(_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
    // Helper function to update existing user
    // Fetches current user data, merges only updated fields, and sends entire payload
    var updateExistingUser = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5(userData, _selectedRoleObjs) {
            var _currentUserResponse$;
            var currentUserResponse, currentUserData, updatedResource;
            return _regenerator().w(function (_context6) {
                while (1)
                    switch (_context6.n) {
                        case 0:
                            _context6.n = 1;
                            return UserAPI.getUsers(userData.email);
                        case 1:
                            currentUserResponse = _context6.v;
                            currentUserData = currentUserResponse === null || currentUserResponse === void 0 || (_currentUserResponse$ = currentUserResponse.resource) === null || _currentUserResponse$ === void 0 ? void 0 : _currentUserResponse$[0];
                            if (currentUserData) {
                                _context6.n = 2;
                                break;
                            }
                            throw new Error('Unable to fetch current user data');
                        case 2:
                            // Merge only updated fields into existing user resource
                            updatedResource = _objectSpread(_objectSpread({}, currentUserData), {}, {
                                userAttributes: _objectSpread(_objectSpread({}, currentUserData.userAttributes), {}, {
                                    name: userData.name,
                                    email: userData.email,
                                    phone: userData.phone
                                })
                            });
                            _context6.n = 3;
                            return UserAPI.updateUser(selectedUser.id, updatedResource);
                        case 3:
                            // Update local state - only update specific fields, preserve role and status
                            setUsers(function (prevUsers) {
                                return prevUsers.map(function (u) {
                                    return u.id === selectedUser.id ? _objectSpread(_objectSpread({}, u), {}, {
                                        name: userData.name,
                                        email: userData.email,
                                        phone: userData.phone
                                    }) : u;
                                });
                            });
                        case 4:
                            return _context6.a(2);
                    }
            }, _callee5);
        }));
        return function updateExistingUser(_x9, _x0) {
            return _ref5.apply(this, arguments);
        };
    }();
    var handleSaveUser = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6(usersData) {
            var newUsers, errors, i, userData, result, errorMessage, _t5, _t6;
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.p = _context7.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            setUserModalError(null);
                            _context7.p = 1;
                            newUsers = [];
                            errors = [];
                            i = 0;
                        case 2:
                            if (!(i < usersData.length)) {
                                _context7.n = 7;
                                break;
                            }
                            userData = usersData[i];
                            _context7.p = 3;
                            console.log("Processing user ".concat(i + 1, "/").concat(usersData.length, ":"), userData.email);
                            _context7.n = 4;
                            return processSingleUser(userData, selectedUser, validateUserData, validateUserRoles, updateExistingUser, createNewUser);
                        case 4:
                            result = _context7.v;
                            if (result) {
                                newUsers.push(result);
                                console.log("Successfully processed user ".concat(i + 1, "/").concat(usersData.length));
                            }
                            _context7.n = 6;
                            break;
                        case 5:
                            _context7.p = 5;
                            _t5 = _context7.v;
                            console.error("Failed to process user ".concat(userData.email, ":"), _t5);
                            errorMessage = _t5 instanceof Error ? _t5.message : constants.team_access_error_unexpected;
                            errors.push("".concat(userData.email, ": ").concat(errorMessage));
                        case 6:
                            i++;
                            _context7.n = 2;
                            break;
                        case 7:
                            handleSaveResults(newUsers, errors, setUsers, setUserModalError, setUserModalOpen, selectedUser !== null);
                            _context7.n = 9;
                            break;
                        case 8:
                            _context7.p = 8;
                            _t6 = _context7.v;
                            console.error('Unexpected error in handleSaveUser:', _t6);
                            setError(constants.team_access_error_unexpected);
                        case 9:
                            _context7.p = 9;
                            setLoading(false);
                            return _context7.f(9);
                        case 10:
                            return _context7.a(2);
                    }
            }, _callee6, null, [[3, 5], [1, 8, 9, 10]]);
        }));
        return function handleSaveUser(_x1) {
            return _ref6.apply(this, arguments);
        };
    }();
    var handleConfirmDelete = /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7() {
            var _t7;
            return _regenerator().w(function (_context8) {
                while (1)
                    switch (_context8.p = _context8.n) {
                        case 0:
                            if (!userToDelete) {
                                _context8.n = 5;
                                break;
                            }
                            setLoading(true);
                            setError(null);
                            _context8.p = 1;
                            _context8.n = 2;
                            return UserAPI.deleteUser(userToDelete.id);
                        case 2:
                            setUsers(function (prevUsers) {
                                return prevUsers.filter(function (u) {
                                    return u.id !== userToDelete.id;
                                });
                            });
                            setConfirmDialogOpen(false);
                            setUserToDelete(null);
                            _context8.n = 4;
                            break;
                        case 3:
                            _context8.p = 3;
                            _t7 = _context8.v;
                            console.error('Failed to delete user:', _t7);
                            setError(constants.team_access_error_delete_user);
                        case 4:
                            _context8.p = 4;
                            setLoading(false);
                            return _context8.f(4);
                        case 5:
                            return _context8.a(2);
                    }
            }, _callee7, null, [[1, 3, 4, 5]]);
        }));
        return function handleConfirmDelete() {
            return _ref7.apply(this, arguments);
        };
    }();
    var handleSelectAll = function handleSelectAll(checked) {
        setSelectedUsers(checked ? users.map(function (u) {
            return u.id;
        }) : []);
    };
    var handleSelectUser = function handleSelectUser(userId, checked) {
        setSelectedUsers(function (prev) {
            return checked ? [].concat(_toConsumableArray(prev), [userId]) : prev.filter(function (id) {
                return id !== userId;
            });
        });
    };
    var handleRoleChange = /*#__PURE__*/ function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee8(userId, newRoles) {
            var user, rolesArray, currentRoles, rolesToAdd, rolesToRemove, _iterator3, _step3, _loop2, _iterator4, _step4, _loop3, _t8, _t9, _t0;
            return _regenerator().w(function (_context1) {
                while (1)
                    switch (_context1.p = _context1.n) {
                        case 0:
                            _context1.p = 0;
                            // Find the user to get their username
                            user = users.find(function (u) {
                                return u.id === userId;
                            });
                            if (user) {
                                _context1.n = 1;
                                break;
                            }
                            return _context1.a(2);
                        case 1:
                            // Ensure newRoles is always an array, dedupe, and filter empty values
                            rolesArray = Array.from(new Set(Array.isArray(newRoles) ? newRoles : [newRoles])).filter(function (role) {
                                return role && role.trim() !== '';
                            }); // Get current user roles (deduped and filtered)
                            currentRoles = Array.from(new Set(Array.isArray(user.role) ? user.role : [user.role])).filter(function (role) {
                                return role && role.trim() !== '';
                            }); // Find roles to add and remove
                            rolesToAdd = rolesArray.filter(function (role) {
                                return !currentRoles.includes(role);
                            });
                            rolesToRemove = currentRoles.filter(function (role) {
                                return !rolesArray.includes(role);
                            }); // Process role additions
                            _iterator3 = _createForOfIteratorHelper(rolesToAdd);
                            _context1.p = 2;
                            _loop2 = /*#__PURE__*/ _regenerator().m(function _loop2() {
                                var roleName, roleObj;
                                return _regenerator().w(function (_context9) {
                                    while (1)
                                        switch (_context9.n) {
                                            case 0:
                                                roleName = _step3.value;
                                                roleObj = roles.find(function (r) {
                                                    return r.role_name === roleName;
                                                });
                                                if (!roleObj) {
                                                    _context9.n = 1;
                                                    break;
                                                }
                                                _context9.n = 1;
                                                return UserAPI.assignRole(user.email, {
                                                    roleId: Number.parseInt(roleObj.role_id)
                                                });
                                            case 1:
                                                return _context9.a(2);
                                        }
                                }, _loop2);
                            });
                            _iterator3.s();
                        case 3:
                            if ((_step3 = _iterator3.n()).done) {
                                _context1.n = 5;
                                break;
                            }
                            return _context1.d(_regeneratorValues(_loop2()), 4);
                        case 4:
                            _context1.n = 3;
                            break;
                        case 5:
                            _context1.n = 7;
                            break;
                        case 6:
                            _context1.p = 6;
                            _t8 = _context1.v;
                            _iterator3.e(_t8);
                        case 7:
                            _context1.p = 7;
                            _iterator3.f();
                            return _context1.f(7);
                        case 8:
                            // Process role removals
                            _iterator4 = _createForOfIteratorHelper(rolesToRemove);
                            _context1.p = 9;
                            _loop3 = /*#__PURE__*/ _regenerator().m(function _loop3() {
                                var roleName, roleObj;
                                return _regenerator().w(function (_context0) {
                                    while (1)
                                        switch (_context0.n) {
                                            case 0:
                                                roleName = _step4.value;
                                                roleObj = roles.find(function (r) {
                                                    return r.role_name === roleName;
                                                });
                                                if (!roleObj) {
                                                    _context0.n = 2;
                                                    break;
                                                }
                                                _context0.n = 1;
                                                return UserAPI.removeRole(user.id, Number.parseInt(roleObj.role_id));
                                            case 1:
                                                console.log("Successfully removed role ".concat(roleName, " from user ").concat(user.email));
                                            case 2:
                                                return _context0.a(2);
                                        }
                                }, _loop3);
                            });
                            _iterator4.s();
                        case 10:
                            if ((_step4 = _iterator4.n()).done) {
                                _context1.n = 12;
                                break;
                            }
                            return _context1.d(_regeneratorValues(_loop3()), 11);
                        case 11:
                            _context1.n = 10;
                            break;
                        case 12:
                            _context1.n = 14;
                            break;
                        case 13:
                            _context1.p = 13;
                            _t9 = _context1.v;
                            _iterator4.e(_t9);
                        case 14:
                            _context1.p = 14;
                            _iterator4.f();
                            return _context1.f(14);
                        case 15:
                            // Update local state
                            setUsers(function (prevUsers) {
                                return prevUsers.map(function (u) {
                                    return u.id === userId ? _objectSpread(_objectSpread({}, u), {}, {
                                        role: rolesArray
                                    }) : u;
                                });
                            });
                            _context1.n = 17;
                            break;
                        case 16:
                            _context1.p = 16;
                            _t0 = _context1.v;
                            console.error('Failed to update roles:', _t0);
                            setError(constants.team_access_error_update_user_roles);
                        case 17:
                            return _context1.a(2);
                    }
            }, _callee8, null, [[9, 13, 14, 15], [2, 6, 7, 8], [0, 16]]);
        }));
        return function handleRoleChange(_x10, _x11) {
            return _ref8.apply(this, arguments);
        };
    }();
    var handleUserDetailsDelete = function handleUserDetailsDelete(user) {
        setUserToDelete(user);
        setConfirmDialogOpen(true);
        setUserDetailsModalOpen(false);
    };
    var handleWorkspaceRoleChange = /*#__PURE__*/ function () {
        var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee9(userId, newWorkspaceRoles) {
            var user, currentRoles, isWorkspaceRole, applicationRoles, combinedRoles;
            return _regenerator().w(function (_context10) {
                while (1)
                    switch (_context10.n) {
                        case 0:
                            // Find the user to get their current roles
                            user = users.find(function (u) {
                                return u.id === userId;
                            });
                            if (user) {
                                _context10.n = 1;
                                break;
                            }
                            return _context10.a(2);
                        case 1:
                            // Get current user roles
                            currentRoles = Array.from(new Set(Array.isArray(user.role) ? user.role : [user.role])).filter(function (role) {
                                return role && role.trim() !== '';
                            }); // Helper to check if a role is a workspace role
                            isWorkspaceRole = function isWorkspaceRole(roleName) {
                                var roleObj = roles.find(function (r) {
                                    return r.role_name === roleName;
                                });
                                if (!roleObj)
                                    return false;
                                if (!roleObj.application_id)
                                    return true;
                                if (typeof roleObj.application_id === 'string') {
                                    var trimmed = roleObj.application_id.trim().toLowerCase();
                                    return trimmed === '' || trimmed === '0' || trimmed === 'null' || trimmed === 'undefined';
                                }
                                if (Array.isArray(roleObj.application_id)) {
                                    if (roleObj.application_id.length === 0)
                                        return true;
                                    return roleObj.application_id.every(function (id) {
                                        if (id === null || id === undefined)
                                            return true;
                                        if (typeof id === 'string') {
                                            var _trimmed = id.trim().toLowerCase();
                                            return _trimmed === '' || _trimmed === '0' || _trimmed === 'null' || _trimmed === 'undefined';
                                        }
                                        return false;
                                    });
                                }
                                return false;
                            }; // Keep application roles, replace workspace roles
                            applicationRoles = currentRoles.filter(function (role) {
                                return !isWorkspaceRole(role);
                            });
                            combinedRoles = [].concat(_toConsumableArray(newWorkspaceRoles), _toConsumableArray(applicationRoles));
                            _context10.n = 2;
                            return handleRoleChange(userId, combinedRoles);
                        case 2:
                            return _context10.a(2);
                    }
            }, _callee9);
        }));
        return function handleWorkspaceRoleChange(_x12, _x13) {
            return _ref9.apply(this, arguments);
        };
    }();
    var handleApplicationRoleChange = /*#__PURE__*/ function () {
        var _ref0 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee0(userId, updatedRoles) {
            return _regenerator().w(function (_context11) {
                while (1)
                    switch (_context11.n) {
                        case 0:
                            _context11.n = 1;
                            return handleRoleChange(userId, updatedRoles);
                        case 1:
                            return _context11.a(2);
                    }
            }, _callee0);
        }));
        return function handleApplicationRoleChange(_x14, _x15) {
            return _ref0.apply(this, arguments);
        };
    }();
    var handleResendEmail = /*#__PURE__*/ function () {
        var _ref1 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee1(userId) {
            var _t1;
            return _regenerator().w(function (_context12) {
                while (1)
                    switch (_context12.p = _context12.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context12.p = 1;
                            _context12.n = 2;
                            return UserAPI.resendRegistrationEmail(userId);
                        case 2:
                            // You could add a success notification here
                            console.log("Registration email resent to ".concat(userId));
                            _context12.n = 4;
                            break;
                        case 3:
                            _context12.p = 3;
                            _t1 = _context12.v;
                            console.error('Failed to resend registration email:', _t1);
                            setError(_t1 instanceof Error ? _t1.message : constants.team_access_error_resend_email);
                        case 4:
                            _context12.p = 4;
                            setLoading(false);
                            return _context12.f(4);
                        case 5:
                            return _context12.a(2);
                    }
            }, _callee1, null, [[1, 3, 4, 5]]);
        }));
        return function handleResendEmail(_x16) {
            return _ref1.apply(this, arguments);
        };
    }();
    var handleResetPassword = /*#__PURE__*/ function () {
        var _ref10 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee10(userId) {
            var _t10;
            return _regenerator().w(function (_context13) {
                while (1)
                    switch (_context13.p = _context13.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context13.p = 1;
                            _context13.n = 2;
                            return UserAPI.resetPassword(userId);
                        case 2:
                            // You could add a success notification here
                            console.log("Password reset initiated for ".concat(userId));
                            _context13.n = 4;
                            break;
                        case 3:
                            _context13.p = 3;
                            _t10 = _context13.v;
                            console.error('Failed to reset password:', _t10);
                            setError(_t10 instanceof Error ? _t10.message : constants.team_access_error_reset_password);
                        case 4:
                            _context13.p = 4;
                            setLoading(false);
                            return _context13.f(4);
                        case 5:
                            return _context13.a(2);
                    }
            }, _callee10, null, [[1, 3, 4, 5]]);
        }));
        return function handleResetPassword(_x17) {
            return _ref10.apply(this, arguments);
        };
    }();
    // Check view permission
    if (!isAuthorized('RBAC:ViewUser')) {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, constants.team_access_access_denied_title), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, constants.team_access_access_denied_desc)));
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            bgcolor: '#f8f8f8'
        }
    }, error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 2
        },
        onClose: function onClose() {
            return setError(null);
        }
    }, error), dataLoading ? /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 4
        }
    }, stateImages !== null && stateImages !== void 0 && stateImages.Loading ? /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: stateImages.Loading,
        alt: "Loading",
        sx: {
            width: 128,
            height: 128
        }
    }) : /*#__PURE__*/ React.createElement(CircularProgress, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            p: 3,
            borderRadius: 2,
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, constants.team_access_header_description), /*#__PURE__*/ React.createElement(Box, null, selectedUsers.length > 0 && isAuthorized('RBAC:DeleteUser') && /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        sx: {
            color: '#DA291C',
            border: '1px solid #DA291C',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            mr: 1
        },
        onClick: handleBulkDeleteUsers
    }, /*#__PURE__*/ React.createElement(DeleteIcon, null)), isAuthorized('RBAC:CreateUser') && /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: handleAddUser,
        sx: {
            textTransform: 'none',
            boxShadow: 'none'
        }
    }, constants.team_access_add_member_button))), /*#__PURE__*/ React.createElement(TableContainer, {
        component: Paper,
        sx: {
            borderRadius: 2,
            boxShadow: 'none',
            border: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Table, {
        sx: {
            minWidth: 650
        }
    }, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            minWidth: 200
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        checked: selectedUsers.length === users.length,
        indeterminate: selectedUsers.length > 0 && selectedUsers.length < users.length,
        onChange: function onChange(e) {
            return handleSelectAll(e.target.checked);
        },
        sx: {
            color: '#d9d9d9',
            '&.Mui-checked': {
                color: '#26890d'
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121',
            whiteSpace: 'nowrap'
        }
    }, constants.team_access_table_header_name), /*#__PURE__*/ React.createElement(FilterIcon, {
        sx: {
            fontSize: 18,
            color: '#26890d'
        }
    }))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, constants.team_access_table_header_email)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            minWidth: 150
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121',
            whiteSpace: 'nowrap'
        }
    }, constants.team_access_table_header_phone_number)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, constants.team_access_table_header_role), /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("strong", null, constants.team_access_role_tooltip_admin_title), /*#__PURE__*/ React.createElement("br", null), constants.team_access_role_tooltip_admin_desc, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("strong", null, constants.team_access_role_tooltip_editor_title), /*#__PURE__*/ React.createElement("br", null), constants.team_access_role_tooltip_editor_desc, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("strong", null, constants.team_access_role_tooltip_viewer_title), /*#__PURE__*/ React.createElement("br", null), constants.team_access_role_tooltip_viewer_desc, /*#__PURE__*/ React.createElement("br", null), constants.team_access_role_tooltip_viewer_note),
        placement: "top",
        slotProps: {
            popper: {
                sx: {
                    '& .MuiTooltip-tooltip': {
                        bgcolor: '#26890D',
                        color: '#ffffff'
                    }
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        sx: {
            fontSize: 20,
            color: '#26890D',
            '&:hover': {
                cursor: 'pointer'
            }
        }
    })))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, constants.team_access_table_header_group)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            minWidth: 120
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121',
            whiteSpace: 'nowrap'
        }
    }, constants.team_access_table_header_status)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            minWidth: 180
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121',
            whiteSpace: 'nowrap'
        }
    }, constants.team_access_table_header_registration_email)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            minWidth: 160
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121',
            whiteSpace: 'nowrap'
        }
    }, constants.team_access_table_header_reset_password)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            minWidth: 140
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121',
            whiteSpace: 'nowrap'
        }
    }, constants.team_access_table_header_date_added)), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            width: 200
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, constants.team_access_table_header_action)))), /*#__PURE__*/ React.createElement(TableBody, null, users.map(function (user, index) {
        return /*#__PURE__*/ React.createElement(TableRow, {
            key: user.id,
            sx: {
                borderTop: index > 0 ? '1px solid #ebebeb' : 'none'
            }
        }, /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55,
                minWidth: 200
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'center',
                gap: 2
            }
        }, /*#__PURE__*/ React.createElement(Checkbox, {
            checked: selectedUsers.includes(user.id),
            onChange: function onChange(e) {
                return handleSelectUser(user.id, e.target.checked);
            },
            sx: {
                color: '#d9d9d9',
                '&.Mui-checked': {
                    color: '#26890d'
                }
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            sx: {
                fontWeight: 600,
                color: '#26890d',
                textDecoration: 'underline',
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            },
            onClick: function onClick() {
                return handleViewUserDetails(user);
            }
        }, user.name))), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#212121"
        }, user.email)), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55,
                minWidth: 150
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#212121"
        }, user.phone || '-')), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5
            }
        }, function () {
            var userRoles = Array.isArray(user.role) ? user.role : [user.role];
            // Dedupe and filter roles
            var validRoles = Array.from(new Set(userRoles.filter(function (role) {
                return role && role.trim() !== '';
            })));
            return validRoles.length > 0 ? validRoles.map(function (roleName) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    key: roleName,
                    label: roleName,
                    size: "small",
                    sx: {
                        backgroundColor: '#f3f8eb',
                        color: '#1a5d09',
                        fontFamily: 'Open Sans',
                        fontSize: 12,
                        fontWeight: 600,
                        height: 20
                    }
                });
            }) : /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                sx: {
                    fontSize: '14px',
                    color: '#888'
                }
            }, "-");
        }())), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5
            }
        }, user.groups && user.groups.length > 0 ? user.groups.map(function (groupName) {
            return /*#__PURE__*/ React.createElement(Chip, {
                key: groupName,
                label: groupName,
                size: "small",
                sx: {
                    backgroundColor: '#e3f2fd',
                    color: '#1565c0',
                    fontFamily: 'Open Sans',
                    fontSize: 12,
                    fontWeight: 600,
                    height: 20
                }
            });
        }) : /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                fontSize: '14px',
                color: '#888'
            }
        }, "-"))), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55,
                minWidth: 120
            }
        }, /*#__PURE__*/ React.createElement(Chip, {
            label: user.status.charAt(0).toUpperCase() + user.status.slice(1),
            size: "small",
            sx: {
                backgroundColor: getStatusBackgroundColor(user.status),
                color: getStatusTextColor(user.status),
                fontFamily: 'Open Sans',
                fontSize: 12,
                fontWeight: 600,
                height: 20
            }
        })), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55,
                minWidth: 180
            }
        }, user.isExternal && user.status === RBAC_CONSTANTS.rbac_user_status_pending ? /*#__PURE__*/ React.createElement(Button, {
            variant: "text",
            startIcon: /*#__PURE__*/ React.createElement(ResendIcon, null),
            onClick: function onClick() {
                return handleResendEmail(user.id);
            },
            sx: {
                color: '#26890d',
                textTransform: 'none',
                fontSize: 14,
                fontWeight: 600,
                padding: '8px 12px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 137, 13, 0.04)'
                }
            }
        }, constants.team_access_resend_button) : /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#666"
        }, "-")), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55,
                minWidth: 160
            }
        }, user.isExternal && user.status === RBAC_CONSTANTS.rbac_user_status_active ? /*#__PURE__*/ React.createElement(Button, {
            variant: "text",
            startIcon: /*#__PURE__*/ React.createElement(ResetIcon, null),
            onClick: function onClick() {
                return handleResetPassword(user.id);
            },
            sx: {
                color: '#26890d',
                textTransform: 'none',
                fontSize: 14,
                fontWeight: 600,
                padding: '8px 12px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 137, 13, 0.04)'
                }
            }
        }, constants.team_access_reset_button) : /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#666"
        }, "-")), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55,
                minWidth: 140
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#212121",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, user.dateAdded)), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                gap: 2
            }
        }, isAuthorized('RBAC:UpdateUser') && /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleEditUser(user);
            },
            sx: {
                color: '#26890d',
                '&:hover': {
                    bgcolor: 'rgba(38, 137, 13, 0.04)'
                }
            }
        }, /*#__PURE__*/ React.createElement(EditIcon, {
            fontSize: "small"
        })), isAuthorized('RBAC:DeleteUser') && /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleDeleteUser(user);
            },
            sx: {
                color: '#da291c',
                '&:hover': {
                    bgcolor: 'rgba(218, 41, 28, 0.04)'
                }
            }
        }, /*#__PURE__*/ React.createElement(DeleteIcon, {
            fontSize: "small"
        })))));
    }))))), /*#__PURE__*/ React.createElement(AddUserModal, {
        open: userModalOpen,
        onClose: function onClose() {
            setUserModalOpen(false);
            setUserModalError(null);
        },
        onSave: handleSaveUser,
        user: selectedUser,
        loading: loading,
        saveError: userModalError
    }), /*#__PURE__*/ React.createElement(UserDetailsModal, {
        open: userDetailsModalOpen,
        onClose: function onClose() {
            return setUserDetailsModalOpen(false);
        },
        user: selectedUserForDetails,
        onDelete: handleUserDetailsDelete,
        onWorkspaceRoleChange: handleWorkspaceRoleChange,
        onApplicationRoleChange: handleApplicationRoleChange
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: confirmDialogOpen,
        setIsOpen: setConfirmDialogOpen,
        bodyText: constants.team_access_delete_confirm_body((_userToDelete$name = userToDelete === null || userToDelete === void 0 ? void 0 : userToDelete.name) !== null && _userToDelete$name !== void 0 ? _userToDelete$name : ''),
        submitFunction: handleConfirmDelete,
        submitButtonText: constants["delete"],
        loading: loading
    })));
};
export default authenticatedRoute(TeamAccess);
